const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_BASE_URL = {
  LOGIN: `${BASE_URL}/auth`,
  SIGNUP: `${BASE_URL}/auth/signup`,
  ASSOCIACAO: `${BASE_URL}/associacao`,
  PESSOA: `${BASE_URL}/pessoa`,
  PESSOA_DEPENDENTE: `${BASE_URL}/pessoa_dependente`,
  EMISSOR: `${BASE_URL}/emissor`,
  ATA: `${BASE_URL}/ata`,
  USUARIO: `${BASE_URL}/usuario`,
  REL_ASSOCIACAO_USUARIO: `${BASE_URL}/rel_associacao_usuario`,
  UF: `${BASE_URL}/uf`,
  MUNICIPIO: `${BASE_URL}/municipio`,
  TEMPLATE: `${BASE_URL}/template`,
  FAVORECIDO: `${BASE_URL}/favorecido`,
  DESPESA: `${BASE_URL}/despesa`,
  PROGRAMA: `${BASE_URL}/programa`,
  ACAO: `${BASE_URL}/acao`,
  SUB_ACAO: `${BASE_URL}/sub_acao`,
  ELEMENTO_DESPESA: `${BASE_URL}/elemento_despesa`,
  FONTE_RECURSO: `${BASE_URL}/fonte_recurso`,
  RELATORIO: `${BASE_URL}/relatorio`,
  IMAGENS: `${BASE_URL}/imagens`,
  ORCAMENTO: `${BASE_URL}/orcamento`,
  ITEM: `${BASE_URL}/item`,
  CONTA: `${BASE_URL}/conta`,
  CONTA_PROGRAMA: `${BASE_URL}/conta-programa`,
  BANCO: `${BASE_URL}/banco`,
  RENDIMENTO: `${BASE_URL}/rendimento`,
  RECEITA: `${BASE_URL}/receita`,
  REDISTRIBUICAO: `${BASE_URL}/redistribuicao`,
  SALDO: `${BASE_URL}/saldo`,
  SALDO_INVESTIMENTO: `${BASE_URL}/saldo-investimento`,
  CONCILIACAO_BANCARIA: `${BASE_URL}/conciliacao-bancaria`,
  EXECUCAO_ORCAMENTARIA: `${BASE_URL}/execucao-orcamentaria`,
  MOVIMENTO: `${BASE_URL}/movimento`,
  MONITORAMENTO: `${BASE_URL}/monitoramento`,
  TRANSPARENCIA_PUBLICA: `${BASE_URL}/publico/transparencia`,
  CNPJ_PROXY: `${BASE_URL}/cnpj`,
  PERMISSAO: `${BASE_URL}/permissao`,
  SESSIONS_ACTIVE: `${BASE_URL}/auth/sessions/active`,
  LOGOUT: `${BASE_URL}/auth/logout`,
  CHANGE_PASSWORD: `${BASE_URL}/usuario/change-password`,
};
